<div class="py-3">
  <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
    <div class="display-4 fw-normal pb-1">{{ 'LETS_SUMMARIZE' | translate }}</div>
    <div class="fs-5 text-muted pb-2">{{ 'SLOGAN_1' | translate }} <strong>{{ 'SLOGAN_2' | translate }}</strong>.</div>
    <div class="fs-6 text-muted">
      {{ 'SUB_SLOGAN_1' | translate }} <strong>{{ 'SUB_SLOGAN_2' | translate }}</strong>, <strong>{{ 'SUB_SLOGAN_3' | translate }}</strong>, {{ 'SUB_SLOGAN_4' | translate }} <strong>{{ 'SUB_SLOGAN_5' | translate }}</strong> {{ 'SUB_SLOGAN_6' | translate }}
    </div>
  </div>
<!--  <main>-->
<!--    <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">-->
<!--      <div class="col">-->
<!--        <div class="card mb-4 rounded-3 shadow-sm">-->
<!--          <div class="card-header py-3">-->
<!--            <h4 class="my-0 fw-normal">🔍 Explorer</h4>-->
<!--          </div>-->
<!--          <div class="card-body">-->
<!--            <h1 class="card-title pricing-card-title">Free</h1>-->
<!--            <ul class="list-unstyled mt-3 mb-4 text-start">-->
<!--              <li>✅ 25 Credits at signup</li>-->
<!--              <li>✅ AI Summary of a single image</li>-->
<!--              <li>❌ Multi-Language</li>-->
<!--              <li>❌ Advanced Options</li>-->
<!--              <li>❌ Export</li>-->
<!--            </ul>-->
<!--            <button type="button" class="w-100 btn btn-lg btn-outline-primary" (click)="openModal()">Sign up for free</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col">-->
<!--        <div class="card mb-4 rounded-3 shadow-sm">-->
<!--          <div class="card-header py-3">-->
<!--            <h4 class="my-0 fw-normal">🌱 Growth</h4>-->
<!--          </div>-->
<!--          <div class="card-body">-->
<!--            <h1 class="card-title pricing-card-title">€ 14,99<small class="text-muted fw-light">/mo</small></h1>-->
<!--            <ul class="list-unstyled mt-3 mb-4 text-start">-->
<!--              <li>✅ 200 Credits</li>-->
<!--              <li>✅ AI Summary of a single image</li>-->
<!--              <li>✅ Multi-Language</li>-->
<!--              <li>✅ Advanced Options</li>-->
<!--              <li>❌ Export</li>-->
<!--            </ul>-->
<!--            <button type="button" class="w-100 btn btn-lg btn-primary" routerLink="/checkout" (click)="addGrowthPlan()">Choose Plan</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col">-->
<!--        <div class="card mb-4 rounded-3 shadow-sm border-primary">-->
<!--          <div class="card-header py-3 text-white bg-primary border-primary">-->
<!--            <h4 class="my-0 fw-normal">🚀 Ultimate</h4>-->
<!--          </div>-->
<!--          <div class="card-body">-->
<!--            <h1 class="card-title pricing-card-title">€ 29,99<small class="text-muted fw-light">/mo</small></h1>-->
<!--            <ul class="list-unstyled mt-3 mb-4 text-start">-->
<!--              <li>✅ 500 Credits</li>-->
<!--              <li>✅ AI Summary of a single image</li>-->
<!--              <li>✅ Multi-Language</li>-->
<!--              <li>✅ Advanced Options</li>-->
<!--              <li>✅ Export</li>-->
<!--            </ul>-->
<!--            <button type="button" class="w-100 btn btn-lg btn-primary" routerLink="/checkout" (click)="addUltimatePlan()">Choose Plan</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="pricing-header p-3 pb-md-4 mx-auto text-center">-->
<!--      <div class="fs-2 fw-normal pb-1">Need credits only?</div>-->
<!--      <div class="btn btn-link btn-sm" (click)="addCredits(100)" routerLink="/checkout">Get 100 credits for € 1.99</div>-->
<!--    </div>-->
<!--  </main>-->
  <hr>
  <main>
    <div class="row row-cols-1 row-cols-md-3 mb-3 text-center mt-3">
      <div class="col">
        <div class="card mb-4 rounded-3 shadow-sm">
          <div class="card-header py-3">
            <h4 class="my-0 fw-normal">🔍 {{ 'PRICING.FREE.TITLE' | translate }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">{{ 'PRICING.FREE.PRICE' | translate }}</h1>
            <ul class="list-unstyled mt-3 mb-4 text-start">
              <li>⭐ {{ 'PRICING.FREE.CREDITS_SIGNUP' | translate }}</li>
              <li>⭐ {{ 'PRICING.FREE.MAX_SUMMARIES' | translate:{count:5} }}</li>
              <li>⭐ {{ 'PRICING.FREE.MULTI_IMAGE' | translate }}</li>
            </ul>
            <button type="button" class="w-100 btn btn-lg btn-outline-primary rounded-5" (click)="openModal()">
              {{ 'PRICING.FREE.BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="card mb-4 rounded-3 shadow-sm">
          <div class="card-header py-3">
            <h4 class="my-0 fw-normal">🌱 {{ 'PRICING.CREDITS_250.TITLE' | translate }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              {{ 'PRICING.CREDITS_250.PRICE' | translate }}<small class="text-muted fw-lighter small">,99</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4 text-start">
              <li>⭐ {{ 'PRICING.CREDITS_250.CREDITS' | translate }}</li>
              <li>⭐ {{ 'PRICING.CREDITS_250.MAX_SUMMARIES' | translate:{count:50} }}</li>
              <li>⭐ {{ 'PRICING.CREDITS_250.MULTI_IMAGE' | translate }}</li>
            </ul>
            <button type="button" class="w-100 btn btn-lg btn-primary rounded-5" routerLink="/checkout" (click)="addCredits(250)">
              {{ 'PRICING.CREDITS_250.BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="card mb-4 rounded-3 shadow-sm border-primary">
          <div class="card-header py-3 text-white bg-primary border-primary">
            <h4 class="my-0 fw-normal">🚀 {{ 'PRICING.CREDITS_750.TITLE' | translate }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              {{ 'PRICING.CREDITS_750.PRICE' | translate }}<small class="text-muted fw-lighter small">,99</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4 text-start">
              <li>⭐ {{ 'PRICING.CREDITS_750.CREDITS' | translate }}</li>
              <li>⭐ {{ 'PRICING.CREDITS_750.MAX_SUMMARIES' | translate:{count:150} }}</li>
              <li>⭐ {{ 'PRICING.CREDITS_750.MULTI_IMAGE' | translate }}</li>
            </ul>
            <button type="button" class="w-100 btn btn-lg btn-primary rounded-5" routerLink="/checkout" (click)="addCredits(750)">
              {{ 'PRICING.CREDITS_750.BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
  <hr>
</div>



<!--ACCORDION FAQ HERE -->
<div class="container py-3 pt-5">
  <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
    <div class="display-5 fw-normal pb-1">{{ 'FAQ' | translate }}</div>
  </div>
  <main>
    <div class="accordion" id="accordionPanelsStayOpenExample">

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingOne">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
            {{ 'QUESTION_1' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
          <div class="accordion-body" [innerHTML]="'ANSWER_1' | translate"></div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
            {{ 'QUESTION_2' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
          <div class="accordion-body">
            <table class="table table-borderless">
              <thead>
              <tr>
                <th>{{ 'TABLE_HEADER_CREDITS' | translate }}</th>
                <th>{{ 'TABLE_HEADER_PRICE' | translate }}</th>
                <th>{{ 'TABLE_HEADER_APPROX_PRICE' | translate }}</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ 'TABLE_ROW_1_CREDITS' | translate }}</td>
                <td>{{ 'TABLE_ROW_1_PRICE' | translate }}</td>
                <td>{{ 'TABLE_ROW_1_APPROX' | translate }}</td>
              </tr>
              <tr>
                <td>{{ 'TABLE_ROW_2_CREDITS' | translate }}</td>
                <td>{{ 'TABLE_ROW_2_PRICE' | translate }}</td>
                <td>{{ 'TABLE_ROW_2_APPROX' | translate }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
            {{ 'QUESTION_3' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
          <div class="accordion-body">{{ 'ANSWER_3' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingFive">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
            {{ 'QUESTION_4' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
          <div class="accordion-body">{{ 'ANSWER_4' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingSix">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false" aria-controls="panelsStayOpen-collapseSix">
            {{ 'QUESTION_5' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSix">
          <div class="accordion-body">{{ 'ANSWER_5' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingSeven">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false" aria-controls="panelsStayOpen-collapseSeven">
            {{ 'QUESTION_6' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSeven">
          <div class="accordion-body">{{ 'ANSWER_6' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingEight">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseEight" aria-expanded="false" aria-controls="panelsStayOpen-collapseEight">
            {{ 'QUESTION_7' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseEight" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingEight">
          <div class="accordion-body">
            {{ 'ANSWER_7_PART1' | translate }}
            <span><a routerLink="/refund">{{ 'ANSWER_7_LINK' | translate }}</a></span>
            {{ 'ANSWER_7_PART2' | translate }}
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingNine">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseNine" aria-expanded="false" aria-controls="panelsStayOpen-collapseNine">
            {{ 'QUESTION_8' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseNine" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingNine">
          <div class="accordion-body">{{ 'ANSWER_8' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingTen">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTen" aria-expanded="false" aria-controls="panelsStayOpen-collapseTen">
            {{ 'QUESTION_9' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseTen" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTen">
          <div class="accordion-body">{{ 'ANSWER_9' | translate }}</div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="panelsStayOpen-headingEleven">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseEleven" aria-expanded="false" aria-controls="panelsStayOpen-collapseEleven">
            {{ 'QUESTION_10' | translate }}
          </button>
        </h2>
        <div id="panelsStayOpen-collapseEleven" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingEleven">
          <div class="accordion-body">{{ 'ANSWER_10' | translate }}</div>
        </div>
      </div>

    </div>
  </main>
  <hr>
  <div class="py-5"></div>
</div>


